import { EdgeValidatePromoCodeRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ValidatePromoCode } from '@/modules/auth/use-cases'

export function makeValidatePromoCode(): ValidatePromoCode {
  return new EdgeValidatePromoCodeRepository(makeSupabaseEdgeHttpClient()).execute
}
